// Brand & platform logo mini-components (inline SVG). Monochrome white by default,
// use `orange` prop for accent. Kept lightweight & consistent.
import React from "react";

const wrap = (children, size = 28) => (
  <span style={{ width: size, height: size, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
    {children}
  </span>
);

export function BrandLogo({ id, size = 28, color = "#FAFAFA" }) {
  const s = size;
  switch ((id || "").toLowerCase()) {
    case "apple":
      return wrap(
        <svg viewBox="0 0 24 24" width={s} height={s} fill={color}><path d="M16.365 1.43c0 1.14-.46 2.24-1.22 3.05-.82.87-2.15 1.55-3.24 1.45-.13-1.13.42-2.31 1.17-3.12.83-.92 2.24-1.59 3.29-1.38zM20.5 17.02c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.4 3.53-4.13 3.55-1.54.02-1.94-1.01-4.03-1-2.09.01-2.53 1.02-4.07 1-1.74-.02-3.06-1.79-4.06-3.36C.29 16.9-.06 12.1 1.62 9.58c1.2-1.79 3.09-2.83 4.87-2.83 1.82 0 2.96 1 4.47 1 1.46 0 2.35-1 4.46-1 1.59 0 3.27.87 4.47 2.36-3.94 2.16-3.3 7.84.61 8.91z"/></svg>, s);
    case "samsung":
      return wrap(
        <svg viewBox="0 0 120 40" width={s * 2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo, sans-serif" fontWeight="800" fontSize="30" letterSpacing="1">SAMSUNG</text></svg>, s);
    case "nokia":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="900" fontSize="30">NOKIA</text></svg>, s);
    case "tecno":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="30" letterSpacing="2">TECNO</text></svg>, s);
    case "infinix":
      return wrap(<svg viewBox="0 0 140 40" width={s*2.6} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="28">infinix</text></svg>, s);
    case "itel":
      return wrap(<svg viewBox="0 0 90 40" width={s*2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="30">itel</text></svg>, s);
    case "oppo":
      return wrap(<svg viewBox="0 0 100 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="900" fontSize="30">OPPO</text></svg>, s);
    case "xiaomi":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="28">Xiaomi</text></svg>, s);
    case "huawei":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="28">HUAWEI</text></svg>, s);
    case "realme":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="28">realme</text></svg>, s);
    case "oneplus":
      return wrap(<svg viewBox="0 0 140 40" width={s*2.6} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="26">OnePlus</text></svg>, s);
    case "wiko":
      return wrap(<svg viewBox="0 0 100 40" width={s*2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="900" fontSize="30">WIKO</text></svg>, s);
    case "lg":
      return wrap(<svg viewBox="0 0 60 40" width={s*1.4} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="900" fontSize="30">LG</text></svg>, s);
    case "motorola":
      return wrap(
        <svg viewBox="0 0 32 32" width={s} height={s} fill="none" stroke={color} strokeWidth="2.2"><circle cx="16" cy="16" r="14"/><path d="M6 20 L12 10 L16 18 L20 10 L26 20"/></svg>, s);
    case "zte":
      return wrap(<svg viewBox="0 0 80 40" width={s*1.8} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="900" fontSize="30">ZTE</text></svg>, s);
    case "sony":
      return wrap(<svg viewBox="0 0 100 40" width={s*2} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="28" letterSpacing="2">SONY</text></svg>, s);
    case "pixel":
      return wrap(
        <svg viewBox="0 0 220 40" width={s*4} height={s} fill={color}>
          <path d="M8 8l6 12-6 12M18 8l6 12-6 12" stroke={color} strokeWidth="2.5" fill="none" strokeLinecap="round"/>
          <text x="34" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="24">Google Pixel</text>
        </svg>, s);
    case "docomo":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.4} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="26">docomo</text></svg>, s);
    case "google":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.4} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="26">Google</text></svg>, s);
    case "android":
      return wrap(
        <svg viewBox="0 0 24 24" width={s} height={s} fill={color}><path d="M17.6 9.48l1.84-3.18a.4.4 0 0 0-.7-.4l-1.86 3.22A11.4 11.4 0 0 0 12 8c-1.7 0-3.32.36-4.88 1.12L5.26 5.9a.4.4 0 0 0-.7.4L6.4 9.48A10.34 10.34 0 0 0 1 18h22a10.34 10.34 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"/></svg>, s);
    case "mediatek":
      return wrap(<svg viewBox="0 0 160 40" width={s*3} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="26">MediaTek</text></svg>, s);
    case "qualcomm":
      return wrap(<svg viewBox="0 0 180 40" width={s*3.4} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="24">Snapdragon</text></svg>, s);
    case "unisoc":
      return wrap(<svg viewBox="0 0 120 40" width={s*2.4} height={s} fill={color}><text x="0" y="30" fontFamily="Chivo,sans-serif" fontWeight="800" fontSize="26">UNISOC</text></svg>, s);
    case "infinity":
      return wrap(
        <svg viewBox="0 0 40 24" width={s * 1.6} height={s}>
          <path d="M8 12 Q12 4, 16 12 T24 12 Q28 20, 32 12 T40 12" stroke={color} strokeWidth="2.5" fill="none" strokeLinecap="round"/>
          <circle cx="20" cy="12" r="2.2" fill="#FF6B00"/>
        </svg>, s);
    case "ios":
      return wrap(<svg viewBox="0 0 24 24" width={s} height={s} fill={color}><path d="M16.365 1.43c0 1.14-.46 2.24-1.22 3.05-.82.87-2.15 1.55-3.24 1.45-.13-1.13.42-2.31 1.17-3.12.83-.92 2.24-1.59 3.29-1.38zM20.5 17.02c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.4 3.53-4.13 3.55-1.54.02-1.94-1.01-4.03-1-2.09.01-2.53 1.02-4.07 1-1.74-.02-3.06-1.79-4.06-3.36C.29 16.9-.06 12.1 1.62 9.58c1.2-1.79 3.09-2.83 4.87-2.83 1.82 0 2.96 1 4.47 1 1.46 0 2.35-1 4.46-1 1.59 0 3.27.87 4.47 2.36-3.94 2.16-3.3 7.84.61 8.91z"/></svg>, s);
    default:
      return wrap(
        <span className="font-display font-black text-[13px]" style={{ color }}>{(id || "?").slice(0, 3).toUpperCase()}</span>, s);
  }
}

export function LHSLogo({ size = 40 }) {
  // Official LHSunlocker circular badge (PNG asset).
  return (
    <img
      src="/lhs-logo.png"
      alt="LHSunlocker"
      width={size}
      height={size}
      className="orange-glow rounded-full"
      style={{ width: size, height: size, objectFit: "contain", display: "inline-block" }}
      data-testid="lhs-logo"
    />
  );
}
